export default __webpack_public_path__ + "static/media/cny-check-in-ms.b2368c57.gif";